/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Ref_N1Inputs */

const en_viewer_ref_n1 = /** @type {(inputs: Viewer_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distinct from the number 42, which is the distinction raw text makes easiest to miss.`)
};

const ko_viewer_ref_n1 = /** @type {(inputs: Viewer_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`숫자 42와 구분됩니다. 원문 텍스트에서 가장 놓치기 쉬운 구분입니다.`)
};

const ja_viewer_ref_n1 = /** @type {(inputs: Viewer_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値の 42 と区別されます。生のテキストで最も見落としやすい区別です。`)
};

/**
* | output |
* | --- |
* | "Distinct from the number 42, which is the distinction raw text makes easiest to miss." |
*
* @param {Viewer_Ref_N1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_ref_n1 = /** @type {((inputs?: Viewer_Ref_N1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Ref_N1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_ref_n1(inputs)
	if (locale === "ko") return ko_viewer_ref_n1(inputs)
	return ja_viewer_ref_n1(inputs)
});